import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "./CartContext";
import { baseURL } from "./api";
import CartModal from "./CartModal";
import logo from "../img/dzyrislogo__1___1_-removebg-preview.png";
import "./Header.css";

const Header = ({ priceType }) => {
  const { cart } = useContext(CartContext);
  const [isCartModalOpen, setCartModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [vendorName, setVendorName] = useState("");
  const [userRole, setUserRole] = useState("");
  const [username, setUsername] = useState("");
  const [userId, setUserId] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const toggleCartModal = () => setCartModalOpen(!isCartModalOpen);
  const toggleDropdown = () => setIsDropdownOpen(prev => !prev);

  const isLoggedIn = !!userId && userRole !== "guest";

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    const storedVendorId = localStorage.getItem("vendorId");
    const role = localStorage.getItem("role");

    if (storedUserId) {
      setUserId(storedUserId);
      fetch(`${baseURL}/getUsers`)
        .then((res) => res.json())
        .then((users) => {
          const user = users.find((u) => u._id === storedUserId);
          if (user) setUsername(user.username);
        })
        .catch((err) => console.error("Error fetching users:", err));
    }

    if (storedVendorId) {
      fetch(`${baseURL}/vendors/${storedVendorId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.vendorName) setVendorName(data.vendorName);
        })
        .catch((err) => console.error("Error fetching vendor:", err));
    }

    if (role) setUserRole(role);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleHome = () => navigate("/");
  const handleOrdersClick = () => {
    navigate("/SaleOrder");
    setIsDropdownOpen(false);
  };
  const handleProfileClick = () => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) navigate(`/vendor/${storedVendorId}`);
    setIsDropdownOpen(false);
  };
  const handleRefundClick = () => {
    navigate("/refund-policy");
    setIsDropdownOpen(false);
  };
  const handleMenu = () => {
    navigate("/home");
    setIsDropdownOpen(false);
  };
  const handleAboutClick = () => {
    navigate("/about");
    setIsDropdownOpen(false);
  };
    const handleContactClick = () => {
    navigate("/contact");
    setIsDropdownOpen(false);
  };
  const handleTermsClick = () => {
    navigate("/terms-conditions");
    setIsDropdownOpen(false);
  };
  const handleLogin = () => {
    localStorage.clear();
    navigate("/login");
    setIsDropdownOpen(false);
  };
  const handleSignup = () => {
    navigate("/signup");
  };

  return (
   <header
  className={`header flex justify-between items-center py-4 ${
    !isLoggedIn ? "header-before-login" : ""
  }`}
>



      {/* Left: Hamburger + Logo */}
      <div className="hamburger-logo-container">
        <button className="hamburger" onClick={toggleMobileMenu} aria-label="Toggle menu">
          <i className="fas fa-bars"></i>
        </button>
        <img
          src={logo}
          alt="Dzyris Frozen Foods"
          className="logo"
          onClick={handleHome}
          style={{ cursor: "pointer" }}
        />
      </div>

      {/* Right: Greeting + Buttons */}
      <div className="flex items-center space-x-4">
        <div className="desktop-nav-buttons">
          <span
            className="vendor-greeting"
            style={{
              display: "inline-block",
              padding: "5px 6px",
              borderRadius: "12px",
              background: "linear-gradient(90deg,rgb(204, 13, 210) 0%,rgb(140, 0, 23) 100%)",
              color: "#fff",
              fontWeight: "600",
              fontSize: "1rem",
              boxShadow: "0 4px 12px rgba(37, 117, 252, 0.6)",
              transition: "transform 0.3s ease",
              cursor: "default",
              userSelect: "none",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            {userRole === "guest" || !isLoggedIn
              ? ""
              : username && userId && !vendorName
              ? `👤 Hello, ${username}`
              : !username && vendorName
              ? `🏢 Hello from ${vendorName}!`
              : "✨ Welcome!"}
          </span>
          

          {isLoggedIn ? (
            <>
              <button className="btn" onClick={handleMenu}>
                <i className="fas fa-home"></i> Home
              </button>
              <button className="btn" onClick={handleAboutClick}>
                <i className="fas fa-info-circle"></i> About
              </button>
                            <button className="btn" onClick={handleContactClick}>
                <i className="fas fa-phone"></i> Distributor Contact
              </button>
              <button className="btn" onClick={handleRefundClick}>
                <i className="fas fa-building"></i> Offices Contact
              </button>
              <button className="btn" onClick={handleTermsClick}>
                <i className="fas fa-file-contract"></i> Terms & Conditions
              </button>
              <button className="btn" onClick={handleOrdersClick}>
                <i className="fas fa-tags"></i> Orders
              </button>
              <button className="btn" onClick={handleProfileClick}>
                <i className="fas fa-user"></i> Profile
              </button>
              <button
  className={`btn cart-btn ${cart?.length > 0 ? "btn-rotate" : ""}`}
  onClick={toggleCartModal}
  aria-label="Open cart"
>
  <span className="cart-content">
    <i className="fas fa-shopping-cart"></i>
    <span>{cart?.length || 0}</span>
  </span>
</button>

              <button className="btn" onClick={handleLogin}>
                <i className="fas fa-sign-out-alt"></i> Logout
              </button>
            </>
          ) : (
            <>
            <button className="btn" onClick={handleAboutClick}>
                <i className="fas fa-info-circle"></i> About
              </button>
              <button className="btn" onClick={handleContactClick}>
                <i className="fas fa-phone"></i> Distributor Contact
              </button>
              <button className="btn" onClick={handleRefundClick}>
                <i className="fas fa-building"></i> Offices Contact
              </button>
              <button className="btn" onClick={handleTermsClick}>
                <i className="fas fa-file-contract"></i> Terms & Conditions
              </button>
              <button className="btn login-btn" onClick={handleLogin}>
                <i className="fas fa-sign-in-alt"></i> Login
              </button>
              <button className="btn login-btn" onClick={handleSignup}>
                <i className="fas fa-user-plus"></i> Signup
              </button>
              <button
  className={`btn cart-btn ${cart?.length > 0 ? "btn-rotate" : ""}`}
  onClick={toggleCartModal}
  aria-label="Open cart"
>
  <span className="cart-content">
    <i className="fas fa-shopping-cart"></i>
    <span>{cart?.length || 0}</span>
  </span>
</button>
              
            </>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
{isMobileMenuOpen && (
  <div className="mobile-menu">
    <ul>
      {isLoggedIn ? (
        <>
          <li onClick={handleMenu}>
            <i className="fas fa-home"></i> Home
          </li>

          <li onClick={handleProfileClick}>
            <i className="fas fa-user"></i> Profile
          </li>

          <li onClick={handleAboutClick}>
            <i className="fas fa-info-circle"></i> About
          </li>

          <li onClick={handleRefundClick}>
            <i className="fas fa-building"></i> Offices Contact
          </li>

          <li onClick={handleTermsClick}>
            <i className="fas fa-file-contract"></i> Terms & Conditions
          </li>

          <li onClick={handleOrdersClick}>
            <i className="fas fa-tags"></i> Orders
          </li>

          <li onClick={handleLogin}>
            <i className="fas fa-sign-out-alt"></i> Logout
          </li>
        </>
      ) : (
        <>
          <li onClick={handleAboutClick}>
            <i className="fas fa-info-circle"></i> About
          </li>

          <li onClick={handleContactClick}>
            <i className="fas fa-phone"></i> Distributor Contact
          </li>

          <li onClick={handleRefundClick}>
            <i className="fas fa-building"></i> Offices Contact
          </li>

          <li onClick={handleTermsClick}>
            <i className="fas fa-file-contract"></i> Terms & Conditions
          </li>
        </>
      )}
    </ul>
  </div>
)}


      {/* Cart Modal */}
      {isCartModalOpen && <CartModal closeModal={toggleCartModal} />}
    </header>
  );
};

export default Header;
